/**
 * Utilidades de inadimplência (status past_due da assinatura).
 *
 * A regra de tolerância é decidida no backend
 * (TrialService::PAST_DUE_GRACE_DAYS + subscription/company/get.php),
 * que devolve past_due_since e past_due_grace_ends_at dentro de `subscription`.
 * Aqui só interpretamos esses campos para a interface.
 */

/**
 * Converte a data vinda da API ('Y-m-d H:i:s') em Date.
 * @param {string|null|undefined} value
 * @returns {Date|null}
 */
export const parseApiDate = (value) => {
  if (!value) return null;
  const date = new Date(String(value).replace(' ', 'T'));
  return isNaN(date.getTime()) ? null : date;
};

/**
 * Indica se a assinatura está com pagamento pendente.
 * @param {Object|null} subscription
 * @returns {boolean}
 */
export const isPastDue = (subscription) => {
  if (!subscription) return false;
  return subscription.subscription_status === 'past_due' ||
         subscription.stripe_subscription_status === 'past_due';
};

/**
 * Indica se a assinatura está inadimplente e ainda dentro da tolerância.
 * Sem data de limite conhecida → considera dentro da tolerância (fallback permissivo,
 * mesmo princípio do backend).
 * @param {Object|null} subscription
 * @returns {boolean}
 */
export const isPastDueInGrace = (subscription) => {
  if (!isPastDue(subscription)) return false;

  const graceEndsAt = parseApiDate(subscription.past_due_grace_ends_at);
  if (!graceEndsAt) return true;

  return graceEndsAt.getTime() > Date.now();
};

/**
 * Data limite da tolerância formatada como DD/MM.
 * @param {string|null|undefined} graceEndsAt
 * @returns {string|null}
 */
export const formatGraceDeadline = (graceEndsAt) => {
  const date = parseApiDate(graceEndsAt);
  if (!date) return null;
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
};
